import { useLayoutEffect, useRef, useState } from "react";

import { useNavigate } from "react-router";

import consumerStyle from "consumer/consumer.module.css"
import step1Style from "./step1.module.css"
import Loading from "consumer/setup/loading";
import Nav from "./nav";

import { get_academy_list } from "consumer/@@@/get_academy_list";


export default function Step1() {

    const navigate = useNavigate();

    const isMounted = useRef(0)

    const [searchRegion, Set_searchRegion] = useState("");
    const [searchAddress, Set_searchAddress] = useState("");

    const [regionList, Set_regionList] = useState([])
    const [addressList, Set_addressList] = useState([]);
    const [academyList, Set_academyList] = useState([]);

    const [addressLoading, Set_addressLoading] = useState(true)
    const [academyLoading, Set_academyLoading] = useState(false)

    // 행사가 있는 지역의 목록만 가져오기
    useLayoutEffect(() => {
        get_academy_list({
            set: 'region',
            Set_regionList: Set_regionList,
            Set_searchRegion: Set_searchRegion,
            Set_addressList: Set_addressList,
            Set_addressLoading: Set_addressLoading
        })
    }, [])

    // 지역을 선택할 때마다 새로운 주소 목록을 가져옴
    useLayoutEffect(() => {
        if(searchRegion !== "") {
            Set_addressLoading(true)

            get_academy_list({
                set: 'address',
                searchRegion: searchRegion,
                searchAddress: "",
                Set_searchAddress: Set_searchAddress,
                Set_addressList: Set_addressList,
                Set_academyList: Set_academyList,
                Set_addressLoading: Set_addressLoading
            })
        }
    }, [searchRegion])

    // 주소를 선택할 때마다 새로운 학원 목록을 가져옴
    useLayoutEffect(() => {
        if(isMounted.current === 0) {
            isMounted.current++
        }
        else if(isMounted.current > 0) {
            if(searchAddress !== "") {
                Set_academyLoading(true)
            }

            if(searchRegion !== "" && searchAddress !== "") {
                get_academy_list({
                    set: 'academy',
                    searchRegion: searchRegion,
                    searchAddress: searchAddress,
                    Set_searchAddress: Set_searchAddress,
                    Set_addressList: Set_addressList,
                    Set_academyList: Set_academyList,
                    Set_addressLoading: Set_addressLoading,
                    Set_academyLoading: Set_academyLoading
                })
            }
        }
    }, [searchAddress])

    return(
        <div
            id="step1"
            className={step1Style['step1']}
        >
            <Nav
                step={1}
            ></Nav>

            <div className={step1Style['regionWrap']}>
                {regionList
                .map((value, index) => {
                    return(
                        <div
                            key={index}
                            className={`
                                ${step1Style['region']}
                                ${value === searchRegion ? step1Style['selected'] : ''}
                            `}
                            onClick={() => Set_searchRegion(value)}
                        >{value}</div>
                    );
                })}
            </div>

            <div className={step1Style['listWrap']}>
                <Loading
                    loading={addressLoading}
                ></Loading>

                <div className={step1Style['addressWrap']}>
                    {addressList
                    .map((value, index) => {
                        return(
                            <div
                                key={index}
                                className={`
                                    ${step1Style['address']}
                                    ${value === searchAddress ? step1Style['selected'] : ''}
                                `}
                                onClick={() => Set_searchAddress(value)}
                            >{value}</div>
                        );
                    })}
                </div>

                <div className={step1Style['academyWrap']}>
                    <Loading
                        loading={academyLoading}
                    ></Loading>

                    {academyList
                    .map((value, index) => {
                        return(
                            <div
                                key={index}
                                className={step1Style['academy']}
                                onClick={() => {
                                    navigate("/step2", {
                                        state: {
                                            branch_id: value['BranchID'],
                                        },
                                    });
                                }}
                            >{value['BranchName']}</div>
                        );
                    })}
                </div>

                {addressList.length === 0 &&
                    <div
                        className={consumerStyle['alarm']}
                    >진행 중인 행사가 없습니다.</div>
                }
            </div>
        </div>
    );
}